const TOKEN = {
  SPACE: 0,
  NAME: 1,
  NUMBER: 2,
  BOOL: 3,
  NULL: 4,
  COMPARISON: 5,
  NOT: 6,
  AND: 7,
  OR: 8,
}

export default TOKEN
